import { Injectable } from '@angular/core';
import { EntityType } from '@shared/models/entity-enum';
import { AppStorageService, USER_LOCATION_PERMS } from '@shared/services/app-storage.service';
import { BehaviorSubject } from 'rxjs';
import {
  CLIPBOARD_SEARCH_STATE_KEY,
  ClipboardSearchConfigByEntity,
  ClipboardSearchConfigs,
  RefreashSearchEvt,
  RefreashSearchEvtActions,
} from './clipboard-search-state.model';
import { ILocationPermission } from '@shared/models/iuser.model';

@Injectable({ providedIn: 'root' })
export class ClipboardSearchStateService {
  constructor(private appStorageSrv: AppStorageService) {}

  #refreshSearch = new BehaviorSubject<RefreashSearchEvt>(null);
  refreshSearch$ = this.#refreshSearch.asObservable();

  getSearchConfigs(entity?: EntityType): ClipboardSearchConfigs | ClipboardSearchConfigByEntity {
    const storedObj = this.appStorageSrv.getItem<ClipboardSearchConfigs>(CLIPBOARD_SEARCH_STATE_KEY) ?? {};
    return storedObj[entity] ?? storedObj;
  }

  getAllowedUsages(): string[] {
    const userLocationPerms = this.appStorageSrv.getItem<ILocationPermission[]>(USER_LOCATION_PERMS) || [];
    return userLocationPerms.map(({ propertyUsageTypeVal }) => propertyUsageTypeVal);
  }

  updateSearchConfigs(entity: EntityType, configs: ClipboardSearchConfigByEntity, setRefresh = true) {
    const storedObj = this.getSearchConfigs();
    this.appStorageSrv.setItem(CLIPBOARD_SEARCH_STATE_KEY, { ...storedObj, [entity]: { ...configs } });
    this.#refreshSearch.next({ entity, refresh: setRefresh, data: configs, action: RefreashSearchEvtActions.Update });
  }

  clearSearchConfigs(entity?: EntityType, setRefresh = true) {
    let newConfigs = {};
    if (entity) {
      const configs = this.getSearchConfigs();
      newConfigs = { ...configs, [entity]: {} };
    }
    this.appStorageSrv.setItem(CLIPBOARD_SEARCH_STATE_KEY, newConfigs);
    this.#refreshSearch.next({
      entity,
      refresh: setRefresh,
      data: entity ? {} : newConfigs,
      action: RefreashSearchEvtActions.ClearAll,
    });
  }
}
